<template>
  <div class="modal fade" id="edit-store-shipping-return-pickup" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 v-if="prefix === 'shipping'" class="modal-title"><i class="fa fa-truck mr-5"></i>{{'shipping_address' | translate}}</h4>
          <h4 v-if="prefix === 'return'" class="modal-title"><i class="fa fa-refresh mr-5"></i>{{'return_address' | translate}}</h4>
          <h4 v-if="prefix === 'pickup'" class="modal-title"><i class="fa fa-map-marker mr-5"></i>PickUp-Adresse</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="shop_name">{{ 'store_name' | translate }}:</label>
                <input id="shop_name" v-model="address['corrected_' + prefix + '_name']" v-validate="{required: true}" placeholder="Filialname" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-9 col-xs-12">
              <div class="form-group">
                <label for="street">{{'shipping_street' | translate}}:</label>
                <input id="street" v-model="address['corrected_' + prefix + '_street']" v-validate="{required: true}" placeholder="Straße" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-3 col-xs-12">
              <div class="form-group">
                <label for="street_number">Nr.:</label>
                <input id="street_number" v-validate="{required: true}" placeholder="Nr." v-model="address['corrected_' + prefix + '_street_no']" type="text"  class="form-control">
              </div>
            </div>
            <div v-if="prefix === 'pickup'" class="col-xs-12">
              <div class="form-group">
                <label>{{'phone_number' | translate}}:</label>
                <input type="text" v-validate="{required: true}" name="pickup_phone" v-model="address['corrected_' + prefix + '_phone']" class="form-control" placeholder="Number">
              </div>
            </div>
            <div class="col-sm-4 col-xs-12">
              <div class="form-group">
                <label for="zip_code">{{'shipping_zip_code' | translate}}:</label>
                <input id="zip_code" placeholder="Postleitzahl" v-validate="{required: true}" v-model="address['corrected_' + prefix + '_zip_code']" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-8 col-xs-12">
              <div class="form-group">
                <label for="city">{{'place' | translate}}</label>
                <input id="city" v-validate="{required: true}" v-model="address['corrected_' + prefix + '_city']" placeholder="Ort" type="text" class="form-control">
              </div>
            </div>
            <div class="col-xs-12">
              <div class="form-group">
                <label for="country">{{'country' | translate}}:</label>
                <select id="country" v-model="address['corrected_' + prefix + '_country']"  v-validate="{required: true}" class="form-control">
                  <option v-for="country in ['DE', 'AT', 'CH', 'NL', 'LU']" v-bind:key="country.id" :value="country">
                    {{ country.toLowerCase() | newCountry($store.getters.language) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-xs-12">
              <span v-show="errors.any()" class="text-danger pull-right">{{ 'all_fields_required' | translate }}</span><br>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-xs-6 text-left">
              <a class="btn btn-app btn-outline no-margin" data-dismiss="modal"><i class="fa fa-times"></i>{{ 'cancel' | translate }}</a>
            </div>
            <div class="col-xs-6 text-right">
              <button data-dismiss="modal"  :disabled="errors.any()" @click="sendDataToParent();" class="btn btn-app btn-success"><i class="fa fa-save"></i>{{'save' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreAddressesModal.vue',
  props: {
    addressForModal: {
      type: Object
    },
    prefix: {
      type: String
    }
  },
  data() {
    return {
      address: {}
    }
  },
  methods: {
    sendDataToParent() {
      this.$validator.validate()
        .then(result => {
          if (result) {
            this.$emit('sendDataToParent', this.address)
          }
        })
    },
    createVariables(){
      this.address = JSON.parse(JSON.stringify(this.addressForModal))
      this.address['corrected_' + this.prefix + '_name'] = this.address[this.prefix + '_name']
      this.address['corrected_' + this.prefix + '_street'] = this.address[this.prefix + '_street']
      this.address['corrected_' + this.prefix + '_street_no'] = this.address[this.prefix + '_street_no']
      this.address['corrected_' + this.prefix + '_zip_code'] = this.address[this.prefix + '_zip_code']
      this.address['corrected_' + this.prefix + '_city'] = this.address[this.prefix + '_city']
      this.address['corrected_' + this.prefix + '_country'] = this.address[this.prefix + '_country']
      if (this.prefix === 'pickup') {
        this.address['corrected_' + this.prefix + '_phone'] = this.address[this.prefix + '_phone']
      }
    }
  },
  mounted() {
  },
  watch: {
    prefix: function (value) {
      if (value.length === 0) {
        return;
      }
      this.prefix = value;
      this.errors.clear();
      this.createVariables();
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/StoreAddressesModal.vue